document.addEventListener('DOMContentLoaded', () => {
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('in-view');
            }
        });
    });

    const animateElements = document.querySelectorAll('.is-animate');
    animateElements.forEach(element => observer.observe(element));
});
